import React from 'react';
import NavbarLanding from '../components/NavbarLanding';
import Footer from './Footer';

const DataProtection = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarLanding />

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2 text-center">Data Protection Policy</h1>
          <p className="text-sm text-gray-500 mb-8 text-center">Last Updated: [Insert Date]</p>

          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
                <p className="text-gray-700">
                  At [Your Website/Company Name], we respect your privacy and are committed to protecting your personal data. This policy explains how we collect, use, and safeguard your information when you use our website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Data We Collect</h2>
                <p className="text-gray-700 mb-3">When you visit or interact with our website, we may collect:</p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li><span className="font-medium">Personal Information</span>: name, email, phone number, or other details you provide through forms or sign-ups.</li>
                  <li><span className="font-medium">Usage Data</span>: IP address, browser type, device information, and pages visited.</li>
                  <li><span className="font-medium">Cookies &amp; Tracking</span>: see our <a className="text-blue-600 underline" href="/cookie-policy">Cookie Policy</a>.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. How We Use Your Data</h2>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Provide and improve our services.</li>
                  <li>Respond to your inquiries or requests.</li>
                  <li>Personalize your website experience.</li>
                  <li>Comply with legal obligations.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Sharing</h2>
                <p className="text-gray-700">
                  We do not sell your personal data. We may share it only with trusted service providers who help us operate the website, or with legal or regulatory authorities if required by law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Data Security</h2>
                <p className="text-gray-700">
                  We use appropriate technical and organizational measures to keep your data secure and prevent unauthorized access, loss, or misuse.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Data Retention</h2>
                <p className="text-gray-700">
                  We only keep your personal data for as long as necessary for the purposes outlined above, unless a longer retention period is required by law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Your Rights</h2>
                <p className="text-gray-700 mb-3">Depending on your location, you may have rights to:</p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Access, update, or correct your personal data.</li>
                  <li>Request deletion of your data.</li>
                  <li>Object to or restrict certain processing activities.</li>
                  <li>Request a copy of your data in a portable format.</li>
                </ul>
                <p className="text-gray-700 mt-3">
                  To exercise these rights, contact us at: [Insert Contact Email].
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. International Data Transfers</h2>
                <p className="text-gray-700">
                  If your data is transferred outside your country, we ensure appropriate safeguards are in place to protect it.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Changes to This Policy</h2>
                <p className="text-gray-700">
                  We may update this policy from time to time. The updated version will always be posted on this page with a new “Last Updated” date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Us</h2>
                <p className="text-gray-700">
                  If you have questions about this policy or how we handle your data, please contact:
                </p>
                <p className="text-gray-700 mt-2">[Company Name]</p>
                <p className="text-gray-700">Email: [Insert Contact Email]</p>
                <p className="text-gray-700">Address: [Insert Company Address]</p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DataProtection;


